import type { Dayjs } from 'dayjs'
import dayjs from 'dayjs'
import type { DateConstraints, DateValidationResult } from './_props'

export const SUPERIOR_DATE_ERROR = "La date saisie ne peut pas être supérieure à la date d'aujourd'hui"
export const INFERIOR_DATE_ERROR = "La date saisie ne peut pas être inférieure à la date d'aujourd'hui"

export const validateDate = (date: Dayjs | null, constraints?: DateConstraints): DateValidationResult => {
    const defaultValidationResult = { isValid: false, errorMessage: 'Date invalide' }

    if (!date) return defaultValidationResult

    const { dateMin = 'infinity', dateMax = 'today' } = constraints || {}
    const today = dayjs()

    if (dateMax === 'today' && dateMin === 'infinity') {
        const isValid = !date.isAfter(today, 'day')
        return {
            isValid,
            errorMessage: isValid ? undefined : SUPERIOR_DATE_ERROR,
        }
    }

    if (dateMax === 'infinity' && dateMin === 'today') {
        const isValid = !date.isBefore(today, 'day')
        return {
            isValid,
            errorMessage: isValid ? undefined : INFERIOR_DATE_ERROR,
        }
    }

    if (dateMax === 'infinity' && dateMin === 'infinity') {
        return { isValid: true }
    }

    return defaultValidationResult
}
